/* eslint-disable react-hooks/exhaustive-deps */
import { each, isEmpty, remove } from "lodash";
import React, { useEffect, useState } from "react";
import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { findModeLabel } from "../../utils/mode";
import { shallowEqual, useSelector } from "react-redux";
import { MANAGEMENT_TYPE } from "../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE";
import { isArray } from "lodash";
import { addManagement, editManagement } from "../../apis/tax-portal";
import { toast } from "../../utils/toast";


const Custodian = (props) => {
  const {
    selectedCustodian, open, setOpen, setSelectedCustodian, submit, permission,
  } = props;

  const { _careCompanies } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
      _careCompanies: store.Data.careCompanies,
    }), shallowEqual
  );


  const [mode, setMode] = useState('create');
  const [activeTab, setActiveTab] = useState("management");
  const [fields, setFields] = useState([]);
  const [checkedList, setCheckedList] = useState([]);

  const defaultForm = {
    name: "", // 수임처명
    ceoName: "",  // 대표자 명
    comNum: "", // 사업자 등록 번호
    rgeNum: "", // 법인 등록 번호
    isWecake: "0",
    memo: "",
    fileIdxes: [],
    type: [],
  };

  const _settingFields = () => {

    const fields = [
      [
        {
          title: "수임회사명",
          key: "companyName",
          type: "input",
          required: form?.isWecake === "0",
          mode: form?.isWecake === "1" || form?.isScraping === "1" ? "view" : mode
        },
        {
          title: "대표자명",
          key: "ceoName",
          type: "input",
          required: form?.isWecake === "0",
          mode: form?.isWecake === "1" || form?.isScraping === "1" ? "view" : mode
        },
      ],
      [
        {
          title: "사업자등록번호",
          key: "bsno",
          type: "input",
          validators: ['comNum'],
          required: form?.isWecake === "0",
          disabled: mode !== "create",
          mode: form?.isWecake === "1" || form?.isScraping === "1" ? "view" : mode
        },
        {
          title: <>대표자 주민번호</>,
          placeholder: '대표자 주민번호 입력',
          titlestyle: {
            lineHeight: '15px'
          },
          key: "resno",
          type: "input",
          validators: ['jumin'],
          required: form?.isWecake === "0",
          mode: form?.isWecake === "1" || form?.isScraping === "1" ? "view" : mode
        },
      ],
      [
        {
          title: "수임유형",
          key: "type",
          type: "checkboxes",
          className: "margin-right-16",
          checkedList,
          options: {
            list: MANAGEMENT_TYPE,
          },
          onChange: (checked, value) => {
            let _selectedCheckboxes = [];
            if (checked) {
              _selectedCheckboxes = [...checkedList, value];
            } else {
              _selectedCheckboxes = remove(checkedList, (v) => v !== value);
            }
            setCheckedList(_selectedCheckboxes);
          },
          required: true,
        },
      ],
      [
        {
          title: "수임일",
          key: "startTime",
          type: "datepicker",
          required: false,
        },
        {
          title: "수임종료일",
          key: "endTime",
          type: "datepicker",
          required: false,
        },
      ],
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
        },
      ],
      [
        {
          title: "메모",
          key: "memo",
          type: "textarea",
        },
      ],
    ];
    setFields(fields);
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setActiveTab("management");
    if (mode !== 'create') {
      setSelectedCustodian(null);
    }

    resetForm();
  };



  const getParams = (form) => {
    const params = {
      companyName: form.companyName,
      ceoName: form.ceoName,
      bsno: form.bsno,
      rgeNum: form.rgeNum,
      type: form.type,
      ...(isArray(form.startTime) && { startTime: form.startTime[0] }),
      ...(isArray(form.endTime) && { endTime: form.endTime[0] }),
      isWecake: form.isWecake,
      isScraping: form.isScraping,
      fileIdxes: form.fileIdxes,
      memo: form.memo || "",
      careCompanyIdx: form.companyToTaxpayer?.companyIdx,
    };

    return params;
  };
  const _submit = (form) => {
    let checkFile = true;
    if (isArray(form.fileIdxes)) {
      each(form.fileIdxes, (item) => {
        const idx = Number(item);
        if (isNaN(idx) || idx <= 0) {
          checkFile = false;
        }
      });
    }

    if (!checkFile) {
      systemAlert('첨부파일을 확인해 주세요.');
      return;
    }


    if (mode === 'create') {
      systemAlert(`"${form.companyName}" 수임회사를 등록하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              addManagement(getParams(form))
                .then(() => {
                  toast.success("등록이 완료되었습니다.");
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    } else {
      systemAlert(`"${form.companyName}" 수임회사를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              toast.success("수정이 완료되었습니다.");
              editManagement(selectedCustodian.idx, getParams(form))
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });

    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields,
    resetForm
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setForm({ type: checkedList });
  }, [checkedList]);

  useEffect(() => {
    _settingFields();
  }, [_careCompanies, activeTab, checkedList, mode, form]);

  useEffect(() => {
    setMode(isEmpty(selectedCustodian) ? 'create' : (permission.level > 1 ? 'modify' : 'view'));
    if (selectedCustodian) {
      const form = {
        ...selectedCustodian,
        isWecake: !isEmpty(selectedCustodian?.companyToTaxpayer?.company) ? "1" : "0",
      };


      setForm(form);
      setOriginForm(selectedCustodian);
      setCheckedList(...selectedCustodian.type);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedCustodian]);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="client-write">
        <ModalHeader>{selectedCustodian && <>"{selectedCustodian.name}"</>} 수임처 정보 {findModeLabel(mode)}</ModalHeader>
        {activeTab === "management" && (
          <Form
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            cancelText={'닫기'}
            submitText={mode === 'create' ? '등록' : '수정'}
            submit={handleSubmit}
            cancel={cancel}
          />
        )}
      </div>
    </Modal>
  );
};

export default Custodian;
